<template>
  <picture class="img-fluid">
    <source :srcset="logoWebp" type="image/webp" />
    <img
      :src="logoPng"
      :alt="$t('App.OrgName')"
      :title="$t('App.OrgName')"
      :style="{ height, width: 'auto' }"
    />
  </picture>
</template>

<script>
import { computed } from "@vue/composition-api"; // Import Composition API functions

import gmpPng from "@/assets/logo/gmp/white.png";
import gmpWebp from "@/assets/logo/gmp/white.webp";

import mwmccPng from "@/assets/logo/mwmcc/white.png";
import mwmccWebp from "@/assets/logo/mwmcc/white.webp";

import { IS_GMP } from "../globals";

export default {
  props: {
    height: {
      type: String,
      default: "50px",
    },
  },
  setup(props) {
    const isGmp = computed(() => IS_GMP);

    const logoPng = computed(() => (isGmp.value ? gmpPng : mwmccPng));
    const logoWebp = computed(() => (isGmp.value ? gmpWebp : mwmccWebp));

    return { logoPng, logoWebp };
  },
};
</script>
